import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_CUISINES,
  REQUEST_CREATE_MASTER_CUISINES,
  SET_MASTER_CUISINES,
  SUCCESS_CREATE_MASTER_CUISINES,
  ERROR_GET_MASTER_CUISINES,
  ERROR_CREATE_MASTER_CUISINES,
  SET_MESSAGE_MASTER_CUISINES,
  SUCCESS_DELETE_MASTER_CUISINES,
  SUCCESS_UPDATE_MASTER_CUISINES,
  REQUEST_DELETE_MASTER_CUISINES,
  REQUEST_UPDATE_MASTER_CUISINES,
  ERROR_DELETE_MASTER_CUISINES,
  ERROR_UPDATE_MASTER_CUISINES,
  REQUEST_MASTER_CUISINES_CATEGORIES,
  SET_MASTER_CUISINES_CATEGORIES,
  ERROR_GET_MASTER_CUISINES_CATEGORIES,
} from "./cuisineActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterCuisines: any[];
  masterCuisinesCat: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterCuisines: [],
  masterCuisinesCat: [],
};

const faqs = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_CUISINES:
    case REQUEST_MASTER_CUISINES_CATEGORIES:
    case REQUEST_CREATE_MASTER_CUISINES:
    case REQUEST_DELETE_MASTER_CUISINES:
    case REQUEST_UPDATE_MASTER_CUISINES:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_CUISINES:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_CUISINES:
      return {
        ...state,
        busy: false,
        message: "",
        masterCuisines: action.payload,
      };

    case SET_MASTER_CUISINES_CATEGORIES:
      return {
        ...state,
        busy: false,
        message: "",
        masterCuisinesCat: action.payload,
      };

    case SUCCESS_CREATE_MASTER_CUISINES:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        masterCuisines: [...state.masterCuisines, action.payload],
      };
    case SUCCESS_DELETE_MASTER_CUISINES:
      return {
        ...state,
        busy: false,
        message: "",
        masterCuisines: state.masterCuisines.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_CUISINES:
      return {
        ...state,
        busy: false,
        message: "",
        masterCuisines: state.masterCuisines.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_CUISINES:
    case ERROR_CREATE_MASTER_CUISINES:
    case ERROR_UPDATE_MASTER_CUISINES:
    case ERROR_DELETE_MASTER_CUISINES:
    case ERROR_GET_MASTER_CUISINES_CATEGORIES:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default faqs;

export function useCuisinesMaster() {
  return useSelector((state: Record<string, any>) => {
    return state.cuisines;
  });
}
